import Vue from 'vue'
import Vuex from 'vuex'
import { VUE_APP_WS_URL } from '../config.js'
import i18n from '@/common/lang';
import { login } from '@/api/login.js'
import { getUserInfo } from "@/api/user";
import { listContents, getSystemTimezone } from '@/api/market'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    innerWidth: 0,
    wsUrl: VUE_APP_WS_URL+"/message",
    marketWsList: [],
    currentLanguage: localStorage.getItem('language')||'en',
    //不显示底部导航的页面
    footerWhiteList: ["reset", "login", "register"],
    lginWhiteList: ["google", "login", "register"],
    isLogin: localStorage.getItem('isLogin')||false,
    isPc: true,
    userInfo: localStorage.getItem('userInfo')? JSON.parse(localStorage.getItem('userInfo')):{},
    token: localStorage.getItem('token')||'',
    contentsList: [],
    langIndex: 0,
    langList: [
      // 'zh': Object.assign(require('@/common/lang/zh-CN'), zhLocale),
      // 'en': Object.assign(require('@/common/lang/en'), enLocale),
      // 'ja': Object.assign(require('@/common/lang/ja'), enLocale),
      // 'ko': Object.assign(require('@/common/lang/ko'), enLocale),
      // 'de': Object.assign(require('@/common/lang/de'), enLocale),
      // 'fr': Object.assign(require('@/common/lang/fr'), enLocale),
      // 'it': Object.assign(require('@/common/lang/it'), enLocale),
      // 'ar': Object.assign(require('@/common/lang/ar'), enLocale),
      // 'hk': Object.assign(require('@/common/lang/zh-HK'), enLocale),
      // 'es': Object.assign(require('@/common/lang/es'), enLocale),
      {
        name: 'English',
        value: 'en'
      },
      {
        name: '日本語',
        value: 'ja'
      },
      {
        name: '한국어',
        value: 'ko'
      },
      {
        name: 'Deutsch',
        value: 'de'
      },
      {
        name: 'français',
        value: 'fr'
      },
      {
        name: 'Italiano',
        value: 'it'
      },
      {
        name: 'Español',
        value: 'es'
      },
      {
        name: 'العربية',
        value: 'ar'
      },
      {
        name: '繁體中文',
        value: 'hk'
      },
      {
        name: '简体中文',
        value: 'zh'
      },
    ],
		areaCodes:[
      "+1", "+7", "+20", "+30", "+31", "+32", "+33", "+34", "+36", "+39", "+40", "+41", "+42", "+43", "+44", "+45", "+46", "+47", "+48", "+49", 
      "+50", "+51", "+52", "+53", "+54", "+55", "+56", "+57", "+58", "+60", "+61", "+62", "+63", "+64", "+65", "+66", "+81", "+82", "+84", "+86", 
      "+90", "+91", "+92", "+93", "+94", "+95", "+96", "+97", "+98", "+212", "+213", "+216", "+218", "+220", "+221", "+222", "+223", "+224", "+225", 
      "+226", "+227", "+228", "+229", "+230", "+231", "+232", "+233", "+234", "+235", "+236", "+237", "+238", "+239", "+240", "+241", "+242", "+243", 
      "+244", "+245", "+246", "+247", "+248", "+249", "+250", "+251", "+252", "+253", "+254", "+255", "+256", "+257", "+258", "+260", "+261", "+262", 
      "+263", "+264", "+265", "+266", "+267", "+268", "+269", "+270", "+271", "+272", "+273", "+274", "+275", "+276", "+277", "+278", "+279", "+280", 
      "+281", "+282", "+283", "+284", "+285", "+286", "+287", "+288", "+289", "+290", "+291", "+292", "+293", "+294", "+295", "+296", "+297", "+298", 
      "+299", "+350", "+351", "+352", "+353", "+354", "+355", "+356", "+357", "+358", "+359", "+370", "+371", "+372", "+373", "+374", "+375", "+376", 
      "+377", "+378", "+379", "+380", "+381", "+382", "+383", "+384", "+385", "+386", "+387", "+388", "+389", "+390", "+391", "+392", "+393", "+394", 
      "+395", "+396", "+397", "+398", "+399", "+400", "+401", "+402", "+403", "+404", "+405", "+406", "+407", "+408", "+409", "+410", "+411", "+412", 
      "+413", "+414", "+415", "+416", "+417", "+418", "+419", "+420", "+421", "+422", "+423", "+424", "+425", "+426", "+427", "+428", "+429", "+430"
    ],
    virtualStatus: localStorage.getItem('virtualStatus')||1,
    showBoard: sessionStorage.getItem('showBoard') || 0,
    darkMode: false, // 夜间模式状态 - 初始化时设为false，在mounted中根据设备类型读取
    // ✅ 系统时区配置（从后端获取）
    systemTimezone: {
      timezoneId: 'Europe/Berlin',
      timezoneName: '中欧时间 (柏林)',
      timezoneOffset: '+01:00',
      offsetHours: 1,
      offsetMilliseconds: 3600000 // 1小时
    }
  },
  getters: {
    marketWsList: state => state.marketWsList,
    getMarkTypeList: () => {
      return [
        {
          label: i18n.t('Market.forex'),
          value: "1",
        },
        {
          label: i18n.t('Market.cypto'),
          value: "2"
        },
        {
          label: i18n.t('Market.stocks'),
          value: "3"
        },
        {
          label: i18n.t('Market.futures'),
          value: "4"
        },
        {
          label: i18n.t('Market.ETF'),
          value: "5"
        }
      ]
    },
    getContentList: state => state.contentsList,
    getUserInfo: state => state.userInfo,
    langList: state => state.langList,
    langIndex: state => state.langIndex,
    virtualStatus: state => state.virtualStatus,
    darkMode: state => state.darkMode, // 获取夜间模式状态
    systemTimezone: state => state.systemTimezone, // ✅ 获取系统时区配置
  },
  mutations: {
    set_isLogin(state, val) {
      state.isLogin=val;
    },
    set_userInfo(state, val) {
      state.userInfo=val;
    },
    SetInnerWidth(state, val) {
      state.innerWidth=val
    },
    CHANGE_WS_MARLET(state, data) {
      state.marketWsList=data;
    },
    changeVirtual(state, val) {
      state.virtualStatus=val;
      localStorage.setItem('virtualStatus', val);
    },
    SET_LANG(state, language) {
      localStorage.setItem('language', language);
      state.currentLanguage=language;
      state.langIndex=state.langList.findIndex((item) => item.value===state.currentLanguage);
      // // //console.log(state.langIndex);
      // 更新 i18n 的当前语言
      // // //console.log(i18n);
      i18n.locale=language;



      // state.marketTypeList = state.marketTypeList
    },
    SET_IS_PC(state, val) {
      state.isPc=val;
    },
    SET_CONTENTS(state, val) {
      state.contentsList=val;
    },
    setToken(state, token) {
      state.token=token;
    },
    setShowBoard(state, val) {
      state.showBoard=val;
      sessionStorage.setItem('showBoard', val);
    },
    // 切换夜间模式
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode;
      // 根据设备类型使用不同的localStorage key
      const storageKey = state.isPc ? 'darkMode_pc' : 'darkMode_mobile';
      localStorage.setItem(storageKey, state.darkMode);
      // 更新HTML根元素的class
      if (state.darkMode) {
        document.documentElement.classList.add('dark-mode');
      } else {
        document.documentElement.classList.remove('dark-mode');
      }
    },
    // 设置夜间模式
    setDarkMode(state, val) {
      state.darkMode = val;
      // 根据设备类型使用不同的localStorage key
      const storageKey = state.isPc ? 'darkMode_pc' : 'darkMode_mobile';
      localStorage.setItem(storageKey, val);
      // 更新HTML根元素的class
      if (val) {
        document.documentElement.classList.add('dark-mode');
      } else {
        document.documentElement.classList.remove('dark-mode');
      }
    },
    // ✅ 设置系统时区
    setSystemTimezone(state, timezone) {
      state.systemTimezone = timezone;
      console.log('✅ 系统时区已更新:', timezone);
    }
  },
  actions: {
    listContents({ commit, state }, lang) {
      return new Promise((resolve, reject) => {
        listContents(lang).then(res => {
          if (res.code=='200') {
            commit('SET_CONTENTS', res.result);
          }
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    loginOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('isLogin')
        commit('setToken', '')
        commit('set_isLogin', false)
        commit('set_userInfo', {})
        resolve();
      })
    },
    login({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        login(params).then(res => {
          if (res.code=='200') {
            localStorage.setItem('token', res.result.token)
            localStorage.setItem('userInfo', JSON.stringify(res.result))
            localStorage.setItem('isLogin', true)
            commit('setToken', res.result.token)
            commit('set_isLogin', true)
            commit('set_userInfo', res.result)
          }
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    GET_USER_INFO({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          if (res.code=='200') {
            // localStorage.setItem('token', res.result.token)
            localStorage.setItem('userInfo', JSON.stringify(res.result))
            localStorage.setItem('isLogin', true)
            // commit('setToken', res.result.token)
            commit('set_isLogin', true)
            commit('set_userInfo', res.result)
          }
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    GET_WS_MARKET({ commit, state }) {
      try {
        return new Promise((resolve, reject) => {
          const ws=new WebSocket(state.wsUrl);
          
          ws.onopen=() => {
            resolve("连接成功");
          };
          
          ws.onmessage=e => {
            if (e.data.includes("[")) {
              const data=JSON.parse(e.data);
              commit('CHANGE_WS_MARLET', data);
            }
          };
          
          ws.onclose=(e) => {
            // WebSocket连接关闭
          };
          
          ws.onerror=(error) => {
            console.error('WebSocket 连接出错:', error);
            reject("连接出错");
          };
        })
      } catch (error) {
        console.error('WebSocket 初始化异常:', error.message);
        reject("连接出错");
      }
    },
    // ✅ 获取系统时区配置
    FETCH_SYSTEM_TIMEZONE({ commit }) {
      return new Promise((resolve, reject) => {
        getSystemTimezone().then(res => {
          if (res.code == '200' && res.result) {
            commit('setSystemTimezone', res.result);
            console.log('✅ 系统时区获取成功:', res.result);
            resolve(res.result);
          } else {
            console.warn('⚠️ 获取系统时区失败，使用默认值');
            resolve(null);
          }
        }).catch(err => {
          console.error('❌ 获取系统时区失败:', err);
          reject(err);
        })
      })
    }
  },
  modules: {
  }
})
